import { h } from 'preact';
import { useMemo } from 'preact/hooks';
import clsx from 'clsx';
import Image from '../utils/image';

const formatBadge = (dataBadge) => {
  const formattedBadge = [];
  if (dataBadge) {
    dataBadge.forEach((field) => {
      formattedBadge[field.key] = field.value;
    });
  }
  return formattedBadge;
};

const Badges = ({ currentProduct, oosBadge = false, isCardBadge = false, customClass = '' }) => {
  const standardBadgeData = !oosBadge
    ? formatBadge(currentProduct?.standardBadge?.reference?.fields)
    : oosBadge;
  const awardBadgeData =
    currentProduct?.awardBadge?.reference?.fields[0]?.reference;

  const standardBadge = useMemo(
    () => (
      <p
        className={clsx(
          'text-black bg-white',
          isCardBadge && 'laptop:px-2.5 px-2 py-[5px] laptop:py-2 font-badge-card',
          !isCardBadge &&
            'cta-large px-2 laptop:px-4 pt-2 laptop:pt-[10px] pb-[7px] laptop:pb-2'
        )}
        style={{
          backgroundColor: standardBadgeData?.background_color,
          color: standardBadgeData?.text_color,
        }}
      >
        {standardBadgeData?.badge_text}
      </p>
    ),
    [currentProduct],
  );

  const awardBadge = useMemo(
    () => (
      <Image
        src={awardBadgeData?.image?.url}
        srcWidths={{ sm: 640, md: 768, lg: 1024, xl: 1280, '2xl': 1536 }}
        classes="laptop:max-w-full laptop:max-w-[42px] max-w-[32px] w-full laptop:w-auto"
      />
    ),
    [currentProduct],
  );

  return (
    <div
      className={clsx(
        'flex justify-between absolute z-[3]',
        isCardBadge && 'top-[5px] laptop:top-2.5 laptop:left-2.5 left-[5px] items-start laptop:w-[calc(100%-20px)] w-[calc(100%-10px)]',
        isCardBadge && oosBadge && '!top-[5px] !left-[5px] laptop:!top-2.5 laptop:!left-2.5',
        !isCardBadge && 'left-5 top-[12px] laptop:left-10 laptop:top-[22px] items-center w-[calc(100%-34px)] laptop:w-[calc(100%-80px)]',
        customClass
      )}
    >
      {standardBadgeData.badge_text && standardBadge}
      {!standardBadgeData.badge_text && <div className='badge-placeholder'></div>}
      {awardBadgeData && awardBadge}
    </div>
  );
};

export default Badges;
